export default __webpack_public_path__ + "media/images/logo-ddf2194e6ff1b15fd2bc1ccdb674bbec.svg";